import { getRegionFormattedPhoneNum } from '../../utils/utils'
import AuthRepository from '../repositories/AuthRepository'
import { SocialLoginRequest, User } from '../types'
import { LogErrorMessage, LogMessage } from './LoggerService'

const socialLoginApi = async (requestData: SocialLoginRequest) => {
  try {
    LogMessage('socialLoginApi', requestData)

    return await AuthRepository.socialLoginApi(requestData)
  } catch (error) {
    LogErrorMessage('socialLoginApi', (error as Error).stack ?? String(error))
    throw error
  }
}
const signIn = async (phone: string) => {
  try {
    const lastFour = phone.slice(-4)
    await LogMessage('signIn', lastFour)

    const formattedPhone = '+82' + phone.replace(/-/g, '')
    return await AuthRepository.signIn({ username: formattedPhone })
  } catch (error) {
    LogErrorMessage('signIn', (error as Error).stack ?? String(error))
    throw error
  }
}

const confirmSignIn = async ({
  phone,
  confirmationCode,
  authSession,
}: {
  phone: string
  confirmationCode: string
  authSession: string
}) => {
  try {
    return await AuthRepository.confirmSignIn({
      data: {
        username: getRegionFormattedPhoneNum(phone, true),
        confirmationCode,
      },
      headers: {
        'Content-Type': 'application/json',
        'auth-session': authSession,
        'refresh-token': '',
      },
    })
  } catch (error) {
    LogErrorMessage('confirmSignIn', (error as Error).stack ?? String(error))
    throw error
  }
}

const refreshToken = async (user: User) => {
  try {
    const { phoneNumber, refreshToken, snsType } = user

    const requestBody: any = {}

    if (phoneNumber) {
      const formattedPhone = '+82' + phoneNumber.replace(/-/g, '')
      requestBody.username = formattedPhone
    } else {
      requestBody.username = user.userId
      requestBody.snsType = snsType
    }

    return await AuthRepository.refreshToken(requestBody, { 'refresh-token': refreshToken })
  } catch (error) {
    LogErrorMessage('refreshToken', (error as Error).stack ?? String(error))
    throw error
  }
}
export { signIn, confirmSignIn, refreshToken, socialLoginApi }
